import React, { useId } from 'react'
import { Checkbox } from '@pandiafi/components'

import {
  ReservationRulesAndTermsLink,
  ReservationRulesAndTermsLinks,
} from 'components/ReservationRulesAndTermsLinks/ReservationRulesAndTermsLinks'

interface ReservationTermsAcceptanceProps {
  contractId: string
  reservableCategory: string | null
  realPropertyHierarchyId: number | null
  fallbackLinks: ReservationRulesAndTermsLink[]
  accepted: boolean
  onAcceptedChange: (accepted: boolean) => void
  children: React.ReactNode
  className?: string
}

export const ReservationTermsAcceptance: React.FC<
  ReservationTermsAcceptanceProps
> = ({
  contractId,
  reservableCategory,
  realPropertyHierarchyId,
  fallbackLinks,
  accepted,
  onAcceptedChange,
  children,
  className,
}) => {
  const checkboxId = useId()

  return (
    <div className={className}>
      <div className="mb-6">
        <ReservationRulesAndTermsLinks
          contractId={contractId}
          reservableCategory={reservableCategory}
          realPropertyHierarchyId={realPropertyHierarchyId}
          fallbackLinks={fallbackLinks}
        />
      </div>
      <div className="flex items-start bg-common-blue-1 px-6 py-5 [&>label]:leading-6">
        <Checkbox
          id={checkboxId}
          checked={accepted}
          labelPosition="right"
          onChange={(e) => onAcceptedChange(e.target.checked)}
        >
          {children}
        </Checkbox>
      </div>
    </div>
  )
}
